import { render, staticRenderFns } from "./discountTypeList.vue?vue&type=template&id=9b212c0a&scoped=true"
import script from "./discountTypeList.vue?vue&type=script&lang=js"
export * from "./discountTypeList.vue?vue&type=script&lang=js"
import style0 from "./discountTypeList.vue?vue&type=style&index=0&id=9b212c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b212c0a",
  null
  
)

export default component.exports